import { EmpresaResponse } from "../../../../types/empresa";

interface Props {
    empresa: EmpresaResponse;
}

export function EmpresaName({ empresa }: Props) {
    return (
        <div className="min-w-[200px] flex items-center justify-center px-3 flex-col ">
            <p className="text-2xl font-semibold text-center text-wrap">
                {empresa.nombre}
            </p>
            <p className="font-[500] text-sm">{empresa.sucursal}</p>
        </div>
    );
}